import type { PulseCard } from "@/types";

import { toSafeHttpUrl } from "./media";
import { splitSummaryParagraphs } from "./summaryHighlights";

export interface CardSource {
  url: string;
  title: string;
  sourceLabel: string;
}

/** Fuentes deduplicadas por URL: artículo canónico + members. */
export function buildCardSources(card: PulseCard): CardSource[] {
  const seen = new Set<string>();
  const sources: CardSource[] = [];

  const add = (url: string, title: string, sourceLabel: string) => {
    const safe = toSafeHttpUrl(url);
    if (!safe || seen.has(safe)) return;
    seen.add(safe);
    sources.push({ url: safe, title: title.trim() || card.title, sourceLabel });
  };

  add(card.url, card.title, card.source);
  for (const member of card.detail.members ?? []) {
    add(member.url, member.title, member.source);
  }

  return sources;
}

export function splitBodyParagraphs(card: PulseCard): string[] {
  const text = card.summary || card.detail.entradilla || "";
  return splitSummaryParagraphs(text);
}
